// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'note-pin';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.813 5.07h2.812a1.125 1.125 0 0 1 1.125 1.126v7.41c0 .297-.118.583-.33.794l-2.716 2.717c-.21.21-.497.329-.795.329H3.375A1.125 1.125 0 0 1 2.25 16.32V6.196A1.125 1.125 0 0 1 3.375 5.07h2.813' />
    <path d='M11.25 17.446V14.07a1.125 1.125 0 0 1 1.125-1.125h3.375M7.313 2.258a1.687 1.687 0 1 0 3.374 0 1.687 1.687 0 0 0-3.374 0zM9 7.883V3.946m-3.937 6.75h7.875M5.063 14.07h3.375' />
  </g>
);

export const viewBox = '0 0 18 18';
